


















































import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import GoalList from "../components/goals/goal-list.vue";

export default Vue.extend({
  components: {
    GoalList,
  },
  data() {
    return {
      isCollapsed: false,
      personalGoalFilter: "All Targets",
      selectedMemberId: NaN,
      showFilterPoptip: false,
      accountId: window.abp && window.abp.custom.currentBillingAccountId ? window.abp.custom.currentBillingAccountId : 0,
      userId: 1,
      name: "Test",
      email: "test@gmail.com",
      phone: 111 - 111 - 1111,
    };
  },
  computed: {
    ...mapState("goal", ["loading"]),
    ...mapGetters("goal", ["canAdd"]),
    ...mapState("session", ["user", "billingAccountIdChangedCount", "billingAccounts"]),
    ...mapState("billing", ["billingAccount"]),
    ...mapGetters("billing", ["hasAccountAdminPermission", "hasUserManagementPermission"]),
    billingAccountId: {
      get() {
        return (this as any).accountId;
      },
      set(newValue) {
        this.accountId = newValue;
        this.$store.dispatch("session/setCurrentBillingAccountId", newValue);
      },
    },
    currentBillingAccount() {
      let accounts = (this as any).billingAccounts.filter((a) => a.id == (this as any).billingAccountId);
      return accounts.length > 0 ? accounts[0] : null;
    },
    hashTags() {
      let hashTags = ["All Targets", "Active Targets", "Completed Targets"];
      let allGoals = this.$store.state.goal.myGoals || [];
      allGoals.forEach((goal) => {
        hashTags = hashTags.concat(goal.hashTagList.map((tag) => "#" + tag.text));
      });
      return [...new Set(hashTags)];
    },
    members() {
      let context = this as any;
      return context.billingAccount ? context.billingAccount.members : [];
    },
  },
  watch: {
    billingAccountIdChangedCount(newVal) {
      this.$store.dispatch("goal/getMyGoals", {});
    },
    user(newVal) {
      let context = this as any;
      if (newVal) {
        context.selectedMemberId = newVal.id;

        (this as any).$intercom.boot({
          user_id: (this as any).user.id,
          user_hash: (this as any).user.intercomUserHash,
          name: (this as any).user.name,
          email: (this as any).user.emailAddress,
          phone: (this as any).user.phoneNumber,
        });
        (this as any).$intercom.show();
      }
    },
    email(email) {
      (this as any).$intercom.update({ email });
    },
  },
  created() {
    (this as any).$store.dispatch("goal/setGoalExclusionFilter", "none");
    this.$store.dispatch("goal/getMyGoals", {});
  },
  mounted() {
    let context = this as any;
    if (context.user) {
      context.selectedMemberId = context.user.id;
    }
  },
  methods: {
    handleAddGoal() {
      (this.$refs.GoalList as any).showGoalCreator();
    },
    getUserTitle(user) {
      let roleName = "User";
      switch (user.role) {
        case 1:
          roleName = "Admin";
          break;
        case 2:
          roleName = "Manager";
          break;
        case 3:
          roleName = "User";
          break;
        default:
          roleName = "User";
          break;
      }

      //return `${user.memberName} - ${roleName}`;
      return `${user.memberName}`;
    },
  },
});
